<template>
  <div class="execution">
      <basic-container>
          <avue-crud ref="crud"
                     :page="page"
                     :data="tableData"
                     :permission="permissionList"
                     :table-loading="tableLoading"
                     :option="tableOption"
                     v-model="form"
                     @on-load="getPage"
                     @refresh-change="refreshChange"
                     @sort-change="sortChange"
                     @search-change="searchChange">
                     <template slot="menuLeft" slot-scope="{ row }">
                        <el-button
                            icon="el-icon-download"
                            v-if="permissions['chain:outsideGarbageTicketCost:excel']"
                            size="small"
                            type="primary"
                            @click="exOut"
                          >
                            导出
                        </el-button>
                      </template>
                      <template slot-scope="{ row,index }" slot="menu">
                        <el-button
                            type="text"
                            v-if="permissions['chain:outsideGarbageTicketCost:detail']"
                            icon="el-icon-view"
                            size="small"
                            plain
                            @click="toDetail(row)">明细</el-button>
                      </template>
          </avue-crud>
      </basic-container>
      <detail v-if="detailVisible" :info="info" :visible.sync="detailVisible"></detail>
  </div>
</template>

<script>
  import {getPage} from '@/api/chain/outsideGarbageTicketCost'
  import {tableOption} from '@/const/crud/chain/outsideGarbageTicketCost'
  import {mapGetters} from 'vuex'
  import { expotOut } from "@/util/down.js";
  import detail from './detail.vue'

  export default {
      name: 'outsideGarbageTicketCost',
      components: {
        detail
      },
      data() {
          return {
              form: {},
              tableData: [],
              page: {
                  total: 0, // 总页数
                  currentPage: 1, // 当前页数
                  pageSize: 20, // 每页显示多少条
                  ascs: [],//升序字段
                  descs: 'year_month'//降序字段
              },
              paramsSearch: {},
              tableLoading: false,
              tableOption: tableOption(this),
              detailVisible:false,
              info:{},   //info.type 1项目剩余总数  2剩余总数
          }
      },
      created() {
      },
      mounted: function () {
      },
      computed: {
          ...mapGetters(['permissions']),
          permissionList() {
              return {
                  addBtn: this.permissions['chain:outsideGarbageTicketCost:add'] ? true : false,
                  delBtn: this.permissions['chain:outsideGarbageTicketCost:del'] ? true : false,
                  editBtn: this.permissions['chain:outsideGarbageTicketCost:edit'] ? true : false,
                  viewBtn: this.permissions['chain:outsideGarbageTicketCost:get'] ? true : false,
                  excelBtn: this.permissions['chain:outsideGarbageTicketCost:excel'] ? true : false,
              };
          }
      },
      methods: {
          searchChange(params,done) {
              params = this.filterForm(params)
              this.paramsSearch = params
              this.page.currentPage = 1
              this.getPage(this.page, params)
              done()
          },
          sortChange(val) {
              let prop = val.prop ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase() : ''
              if (val.order == 'ascending') {
                  this.page.descs = []
                  this.page.ascs = prop
              } else if (val.order == 'descending') {
                  this.page.ascs = []
                  this.page.descs = prop
              } else {
                  this.page.ascs = []
                  this.page.descs = []
              }
              this.getPage(this.page)
          },
          getPage(page, params) {
              this.tableLoading = true
              getPage(Object.assign({
                  current: page.currentPage,
                  size: page.pageSize,
                  descs: this.page.descs,
                  ascs: this.page.ascs,
                  type:3,
              }, params, this.paramsSearch)).then(response => {
                  this.tableData = response.data.data.records
                  this.page.total = response.data.data.total
                  this.page.currentPage = page.currentPage
                  this.page.pageSize = page.pageSize
                  this.tableLoading = false
              }).catch(() => {
                  this.tableLoading = false
              })
          },
          /**
           * 刷新回调
           */
          refreshChange(page) {
              this.getPage(this.page)
          },
          exOut(){
            let params = Object.assign({},this.paramsSearch)
            let url = '/chain/companyticketpurchase/purchaseAvgMonthCostExportExcel'
            expotOut( params,url,'外部泥尾票成本');
          },
          toDetail(row,type){
            this.info = row
            this.info.type = type
            this.detailVisible = true
          },
      }
  }
</script>

<style lang="scss" scoped>
</style>
